import React from 'react';

const SkillDeckLogo = ({ size = 36, className = '' }) => (
  <svg viewBox="0 0 120 120" width={size} height={size} xmlns="http://www.w3.org/2000/svg" className={className}>
    <defs>
      <linearGradient id="nc1" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stopColor="#1e1060"/><stop offset="100%" stopColor="#0c1e70"/></linearGradient>
      <linearGradient id="nc2" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stopColor="#3520a0"/><stop offset="100%" stopColor="#1535a8"/></linearGradient>
      <linearGradient id="nc3" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stopColor="#2a1880"/><stop offset="100%" stopColor="#0d2a8a"/></linearGradient>
      <linearGradient id="ne" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stopColor="#a78bfa"/><stop offset="100%" stopColor="#3b82f6"/></linearGradient>
      <linearGradient id="nb" x1="0%" y1="0%" x2="0%" y2="100%"><stop offset="0%" stopColor="#e0d4ff"/><stop offset="100%" stopColor="#93c5fd"/></linearGradient>
      <filter id="nef"><feGaussianBlur stdDeviation="2" result="b"/><feComposite in="SourceGraphic" in2="b" operator="over"/></filter>
      <filter id="nbf" x="-50%" y="-50%" width="200%" height="200%"><feGaussianBlur stdDeviation="1.5" result="b"/><feComposite in="SourceGraphic" in2="b" operator="over"/></filter>
      <filter id="nsh"><feDropShadow dx="0" dy="4" stdDeviation="8" floodColor="#6c47ff" floodOpacity="0.5"/></filter>
    </defs>
    <g transform="translate(60,62)" filter="url(#nsh)">
      <g transform="rotate(-18) translate(-18,4)">
        <rect x="-22" y="-34" width="44" height="58" rx="8" fill="none" stroke="url(#ne)" strokeWidth="1" opacity="0.5" filter="url(#nef)"/>
        <rect x="-22" y="-34" width="44" height="58" rx="8" fill="url(#nc3)" opacity="0.8"/>
      </g>
      <g transform="rotate(18) translate(18,4)">
        <rect x="-22" y="-34" width="44" height="58" rx="8" fill="none" stroke="url(#ne)" strokeWidth="1" opacity="0.5" filter="url(#nef)"/>
        <rect x="-22" y="-34" width="44" height="58" rx="8" fill="url(#nc2)" opacity="0.8"/>
      </g>
      <g>
        <rect x="-24" y="-36" width="48" height="62" rx="9" fill="none" stroke="url(#ne)" strokeWidth="1.5" opacity="1" filter="url(#nef)"/>
        <rect x="-24" y="-36" width="48" height="62" rx="9" fill="url(#nc1)"/>
        <g filter="url(#nbf)">
          <polygon points="4,-17 -6,-1 2,-1 -4,17 8,0 -1,0 6,-17" fill="#a78bfa" opacity="0.3"/>
          <polygon points="4,-17 -6,-1 2,-1 -4,17 8,0 -1,0 6,-17" fill="url(#nb)"/>
        </g>
      </g>
    </g>
  </svg>
);

export default SkillDeckLogo;
